import React from "react";
// import PropTypes from "prop-types";
import Helmet from "react-helmet";

// css
import "../css/bootstrap.css";
import "../css/animate.css";
import "../css/fontello.css";
import "../css/fontello-codes.css";
import "../css/fontello-embedded.css";
import "../css/owl.transitions.css";
import "../css/full-slider.css";
import "../css/responsive.css";
import "../css/bootstrap.css";
import "../css/menu-hamburger.css";
import "../css/style.css";
import "../css/custom.css";

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FullScreenSlider from "../components/FullScreenSlider";
import ParallaxDivider from "../components/ParallaxDivider";
import FeaturedProjectSlider from "../components/FeaturedProjectSlider";
import { ThemeProvider } from "styled-components";
// import "../scripts/owl.carousel.min.original.js";


const theme = {
  colors: {
    orange: "#ef4b2f",
    black: "#030b14",
    white: "#fff",
    gray: "#bdbdbd",
    grey: "#bdbdbd"
  }
};

class TemplateWrapper extends React.Component {
  componentDidMount() {
    //JS
    require("../scripts/navigation.js");
    require("../scripts/skip-link-focus-fix.js");
    require("../scripts/jquery.parallax-1.1.3.js");
    require("../scripts/bootstrap.js");
    require("../scripts/smooth-scroll.js");
    // for some reason wow.js import didn't work here so it's been moved to main.js
    require("../scripts/imagesloaded.pkgd.min.js");
    // require("../scripts/owl.carousel.min.js");
    // require("../scripts/home-sliders.js");
    require("../scripts/main.js");
  }

  render() {
    const data = this.props.data;

    return (
      <div>
        <Helmet
          title="Moon Beyond Co"
          meta={[
            { name: "description", content: "Creative design and development agency" },
            { name: "keywords", content: "design, development, web development" }
          ]}
        >
          <link
            href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
            rel="stylesheet"
            integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
            crossorigin="anonymous"
          />
        </Helmet>

        <Navbar pages={data.mainMenu.items} />
        <ThemeProvider theme={theme}>{this.props.children()}</ThemeProvider>
        <ThemeProvider theme={theme}><Footer pages={data.footerMenu.items} /></ThemeProvider>
      </div>
    );
  }
}

export const query = graphql`
  query TemplateWrapperQuery {
    site {
      siteMetadata {
        title
      }
    }
    mainMenu: wordpressWpApiMenusMenusItems(name: { eq: "Main Menu" }) {
      name
      items {
        object_slug
        title
      }
    }
    footerMenu: wordpressWpApiMenusMenusItems(name: { eq: "Footer Menu" }) {
      name
      items {
        object_slug
        title
      }
    }
    allWordpressPage {
      edges {
        node {
          title
          slug
        }
      }
    }
  }
`;

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js